import "./App.css";
import Game from "./components/Game";

function App() {
  return (
    <div className="App">
      <div className="App-body">
        <Game />
      </div>
    </div>
  );
}

export default App;
